export const ru = {
  title: 'Импрессум (выходные данные)',
  subtitle: 'Обязательные сведения в соответствии с Регламентом ЕС 2018/302 и эстонским Коммерческим кодексом (äriseadustik) · По состоянию на: 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Поставщик услуг',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Эстония (Estonia)\n\n- **Registrikood (регистрационный номер в коммерческом реестре):** 14744075\n- **Идентификационный номер плательщика НДС / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Реестр:** Eesti äriregister (Эстонский коммерческий реестр)\n- **Организационно-правовая форма:** Osaühing (OÜ) — общество с ограниченной ответственностью по эстонскому праву\n- **Лицензировано и регулируется в:** Эстонская Республика, Европейский союз',
    },
    {
      id: 'responsible',
      title: 'Ответственный за содержание',
      body:
        '**Andreas A. Gleim**\nДиректор / Ответственный за содержание в соответствии с эстонским Коммерческим кодексом (äriseadustik) и § 18 MStV (Германия)\n\nЭл. почта: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Контакты',
      body:
        'Эл. почта: [logixa.one/kontakt](/kontakt)\nВеб-сайт: [https://logixa.one](https://logixa.one)\n\nЗапросы по платформе, вопросы партнёрства, прессы и защиты данных можно направлять нам по указанному выше адресу электронной почты или через [контактную форму](/kontakt).',
    },
    {
      id: 'eu',
      title: 'Разрешение споров в ЕС',
      body:
        'Европейская комиссия предоставляет платформу для онлайн-урегулирования споров (OS):\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nМы не готовы и не обязаны участвовать в процедуре урегулирования споров в органе по разрешению потребительских споров.',
    },
    {
      id: 'liability',
      title: 'Ответственность за содержание',
      body:
        'Как поставщик услуг мы несём ответственность за собственное содержание на этих страницах согласно § 7 абз. 1 TMG (Германия) и эстонскому InfoTS в соответствии с общими законами. Однако согласно §§ 8–10 TMG мы как поставщик услуг не обязаны контролировать передаваемую или хранимую чужую информацию.\n\nОбязательства по удалению или блокировке использования информации в рамках общих законов остаются при этом в силе. Ответственность в этом отношении, однако, возможна только с момента, когда нам стало известно о конкретном правонарушении.',
    },
    {
      id: 'liability-links',
      title: 'Ответственность за ссылки',
      body:
        'Наше предложение содержит ссылки на внешние веб-сайты третьих лиц, на содержание которых мы не имеем влияния. Поэтому мы не можем нести ответственность за это чужое содержание. За содержание сайтов, на которые ведут ссылки, всегда отвечает соответствующий поставщик или оператор этих сайтов.',
    },
    {
      id: 'copyright',
      title: 'Авторское право',
      body:
        'Содержание и произведения, созданные операторами сайта на этих страницах, защищены авторским правом. Воспроизведение, обработка, распространение и любой вид использования за пределами границ авторского права требуют письменного согласия соответствующего автора или создателя.\n\nЗагрузки и копии этой страницы разрешены только для частного, некоммерческого использования.',
    },
  ],
};
